import { useEffect } from 'react';
import axios from 'axios';
import { Howl } from 'howler';
import { API_URL } from '../api-config';
import React from 'react';
import { handleAuthError } from './ValidateToken';
import { useNavigate } from 'react-router-dom';

const useLoadCurrentChapter = ({
  currentChapterIndex,
  audiolibroId,
  usuarioId,
  token,
  volume,
  playbackRate,
  progress,
  setDuration,
  setIsCurrentChapterLoaded,
  setIsLoadingCurrentChapter,
  setError,
  updateProgress,
  saveProgress,
  setCurrentChapterIndex,
  capitulos,
  soundRef,
  loadedChapters,
  isInitialLoad,
}) => {
  const isLoadingRef = React.useRef(false);
  const navigate = useNavigate();
  
  useEffect(() => {
    if (currentChapterIndex !== null && !isLoadingRef.current) {
      setIsCurrentChapterLoaded(false);
      setIsLoadingCurrentChapter(true);
      isLoadingRef.current = true;

      const loadAudio = async () => {
        try {
          if (soundRef.current) {
            soundRef.current.stop();
            soundRef.current.unload();
            soundRef.current = null;
          }

          let audioUrl = loadedChapters.current[currentChapterIndex];

          if (!audioUrl) {
            const newAudioUrl = `${API_URL}/stream-audio-simple/${usuarioId}/${audiolibroId}/${currentChapterIndex}`;
            const response = await axios.get(newAudioUrl, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
              responseType: 'blob',
            });

            const audioBlob = new Blob([response.data], { type: 'audio/mpeg' });
            audioUrl = URL.createObjectURL(audioBlob);
            loadedChapters.current[currentChapterIndex] = audioUrl;
          }

          soundRef.current = new Howl({
            src: [audioUrl],
            html5: true,
            format: ['mp3'],
            volume: volume,
            onload: () => {
              console.log("Archivo cargado correctamente");
              setDuration(soundRef.current.duration());

              if (isInitialLoad.current) {
                if (progress > 0) {
                  soundRef.current.seek(progress);
                }
                isInitialLoad.current = false;
              }

              setIsCurrentChapterLoaded(true);
              setIsLoadingCurrentChapter(false);
              isLoadingRef.current = false;

              setTimeout(() => {
                if (soundRef.current) {
                  soundRef.current.play();
                }
              }, 500);
            },
            onplay: () => updateProgress(),
            onpause: () => saveProgress(),
            onend: () => playNextChapter(),
            onloaderror: (id, error) => {
              console.error("Error al cargar el archivo:", error);
              setError(`Error al cargar el archivo: ${error}`);
              setIsLoadingCurrentChapter(false);
              isLoadingRef.current = false;
            },
          });

          soundRef.current.volume(volume);
          soundRef.current.rate(playbackRate);
        } catch (error) {
          console.error("Error al cargar el audio:", error);
          setError("Error al cargar el audio. Por favor, intenta nuevamente.");
          handleAuthError(error, navigate);
          setIsLoadingCurrentChapter(false);
          isLoadingRef.current = false;
        }
      };

      loadAudio();
    }

    return () => {
      if (soundRef.current) {
        soundRef.current.stop();
        soundRef.current.unload();
      }
    };
  }, [currentChapterIndex, audiolibroId, token]);

  const playNextChapter = () => {
    if (currentChapterIndex < capitulos.length) {
      const nextChapterIndex = currentChapterIndex + 1;
      setCurrentChapterIndex(nextChapterIndex);

      if (soundRef.current) {
        soundRef.current.stop();
        soundRef.current.unload();
        soundRef.current = null;
      }
    } else {
      console.log("No hay más pistas disponibles.");
    }
  };
};

export default useLoadCurrentChapter;